import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface IncTxRommsProps {
  onBack: () => void;
}

export default function IncTxRomms({ onBack }: IncTxRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Income Tax" />;
}



